const isClient = typeof window !== "undefined";

export { isClient };
